import { fetchItemsInBounds } from './supabaseApi'
import newBox from './zoomChecker'


export const fetchItems=async (_ne,_sw, force = false)=>{
    let data = null
    let warrantsRefresh = force || newBox(_ne,_sw)
    if (warrantsRefresh){
        data = await fetchItemsInBounds(_ne, _sw)
    }


    return data
}


export const fetchAllItems=async ()=>{
    return []
}
